import { useBoot } from "../components/Layout";
import { SOLUTIONS } from "./solutions";
import { SECTORS } from "./sectors";
import { IMG, mediaUrl } from "./images";

// DB rows come as { slug, order, published, data: { icon, fr, en } }.
// Normalise to the same shape the static catalogues use: { slug, icon, fr, en }.
const normalize = (rows) =>
  rows.map((r) => ({ slug: r.slug, icon: (r.data || {}).icon, ...(r.data || {}) }));

export const useSolutions = () => {
  const boot = useBoot();
  const rows = boot?.services;
  return rows && rows.length ? normalize(rows) : SOLUTIONS;
};

export const useSectors = () => {
  const boot = useBoot();
  const rows = boot?.sectors;
  return rows && rows.length ? normalize(rows) : SECTORS;
};

// Merge CMS media overrides (storage paths / URLs) over the curated defaults.
export const useSiteImages = () => {
  const boot = useBoot();
  const media = boot?.settings?.media || {};
  const merged = { ...IMG };
  for (const [k, v] of Object.entries(media)) {
    if (v) merged[k] = mediaUrl(v);
  }
  return merged;
};

// Overlay CMS-managed homepage copy for the active locale on top of the static dictionary.
export const mergeHome = (baseT, boot, lang) => {
  const override = boot?.settings?.home_content?.[lang];
  return override ? { ...baseT, ...override } : baseT;
};
